import type { PropsWithChildren } from 'react';
import { createContext, useMemo, useRef } from 'react';

import { defaults } from '../defaults';
import type { LbOptions } from '../types';

import { createLbStore, initialState } from './slices';

export const LbOptionsContext = createContext<LbOptions>(null);

export const LbContext = createContext<ReturnType<typeof createLbStore>>(null);

const LbContextProvider = ({ options, children }: PropsWithChildren<{ options: LbOptions }>) => {
  const value = useMemo(() => ({ ...defaults, ...options }), [options]);
  const store = useRef(
    createLbStore({
      blogId: options.blogId,
      ...initialState,
    }),
  ).current;

  return (
    <LbContext key={options.blogId} value={store}>
      <LbOptionsContext value={value}>{children}</LbOptionsContext>
    </LbContext>
  );
};

export { LbContextProvider };
